import React from 'react';
import { Link } from 'react-router-dom';
import type { QuotationConfirmedOrderDto } from '../../lib/quotationApi';

/**
 * D81 (owner-approved flow, 2026-09-28): an order belongs to its RFQ, and once there is one its
 * quantities change only on the order (confirmedOrderQuantity.service). A quantity edited on the
 * quotation — this version or another of the RFQ — no longer reaches it; this says so and links
 * there. `order` is read by the server with the quotation (getQuotationById).
 */
export const OrderedQuotationNote: React.FC<{ order?: QuotationConfirmedOrderDto | null }> = ({ order }) => {
  if (!order) return null;
  return (
    <div role="note" className="rounded-md border border-cyan-200 bg-cyan-50 px-3 py-2 text-xs text-cyan-800">
      Quantities here no longer change order {order.quotationNumber || 'confirmed from this RFQ'} —{' '}
      <Link to={`/confirmed-orders/${order._id}`} className="font-semibold underline">
        change them on the order
      </Link>
      .
    </div>
  );
};
